import { EnhancedLoadingState } from './EnhancedLoadingStates';

/**
 * Authentication-Specific Loading States
 *
 * Pre-configured loading states for different authentication phases.
 * Separated from components to maintain Fast Refresh compatibility.
 */
export const AuthLoadingStates = {
  /**
   * Preparing for redirect
   */
  PreparingRedirect: () => (
    <EnhancedLoadingState
      message="Preparing secure connection..."
      submessage="You'll be redirected to sign in shortly"
      variant="pulse"
      progress={25}
    />
  ),

  /**
   * Mobile-optimized loading
   */
  Mobile: (message?: string) => (
    <EnhancedLoadingState
      message={message ?? 'Authenticating...'}
      submessage="Please wait"
      variant="spinner"
      size="lg"
    />
  ),
};
